export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlHAMBS', function (
      AonApplicationService,
      AonConfig,
      $log,
      $sce,
      $scope) {

    let ctrl = $scope.$parent.ctrl;
    const iframe = _.get(AonApplicationService.product.fund, 'api.iframe', '');
    this.nab_iframe_source = $sce.trustAsResourceUrl(iframe);
    this.creditCardScript = AonConfig.corporate.hambs_credit_card_script;

    this.loading = {iframe: false};

    let onNABIframeMessage = (e) => {
      console.log(e)
      $scope.$apply( () => { processNABIframeResponse(e.data); });
    };

    let processNABIframeResponse = (data) => {
      const json = JSON.parse(data);
      if (json.hasOwnProperty("CRN")) {
        const result = {
          crn: json.CRN,
          pan: json.pan,
          rescode: json.rescode,
          restext: json.restext,
          expMonth: json.expMonth,
          expYear: json.expYear,
          cardType: json.cardType,
          cardName: _.get(ctrl.application, 'payment.nab.cardName', undefined),
        };

        if (json.hasOwnProperty("CRN") && json.CRN.length &&
            json.hasOwnProperty("pan") && json.pan.length) {
          ctrl.application.payment.nab = result;
        } else {
          ctrl.application.payment.nab = null;
        }
      }
    };

    const realSubmit = ctrl.onSubmit;

    const haveCreditCardDetails = () => {
      let result = _.get(ctrl.application, 'payment.nab.crn', '');
      return result.length;
    };

    const isPaymentTypeDirectDebit = () => ctrl.application.payment.type == 0;
    const isPaymentTypeRenewal = () => ctrl.application.payment.type == 2;

    this.isPaymentTypeDirectDebit = isPaymentTypeDirectDebit;
    this.isPaymentTypeRenewal = isPaymentTypeRenewal;

    ctrl.onSubmit = function(form, forceNoValidation=false) {
      ctrl.debugTrace += `\nHAMBS on submit, forceNoValidate: ${forceNoValidation}`;
      ctrl.debugTrace += '\n' + (new Error()).stack;
      $log.warn('HAMBS on submit, forceNoValidate:', forceNoValidation);
      if (ctrl.application.payment.type == 1 && haveCreditCardDetails()) {
        realSubmit.call(ctrl, form, forceNoValidation);
      } else if (isPaymentTypeDirectDebit() || isPaymentTypeRenewal()) {
        realSubmit.call(ctrl, form, forceNoValidation);
      } else {
        console.log("Error", form);
      }
    };

    this.iframeLoaded = () => {
      $scope.$apply( () => { this.loading.iframe = false; } );

      // Check for hambs iframe
      var hambs_iframe = $(".hambs-payment-iframe");

      // It seems that we need to explicitly set the iframe height on load, else
      // the content inside the iframe is not showing correctly.
      setTimeout(() => {
        // We need to set the height to something other than it's current value, to
        // trigger the inner content to display
        const initialHeight = hambs_iframe.height() || 210;
        hambs_iframe.height(initialHeight + 1);
      }, 0);

      if (hambs_iframe.length) {
        // Need to trigger Iframe submission here
        //hambs_iframe.get(0).contentWindow.postMessage("POST", iframe_host);
        if (window.addEventListener) {
          window.addEventListener("message", onNABIframeMessage, false);
        } else if (window.attachEvent) { // IE8
          window.attachEvent("onmessage", onNABIframeMessage);
        }
      }
    };

    this.changePaymentMethod = () => {
      this.loading.iframe = true;
    };

    this.showVitality = () => {
      const vitality = _.get(ctrl.fieldsets, 'personal.vitality', null);
      return (
          vitality &&
          ctrl.application.zoho &&
          vitality.channel === ctrl.application.zoho.channel &&
          vitality.lead_category === ctrl.application.zoho.lead_category
      );
    };
    
    this.medicareExpiryNoDaysRequired = (cardColor) => {
      let daysRequired = false;
      const colorsRequiringDays = [
          AonConfig.jsConstants.MedicareCardColors.Blue,
          AonConfig.jsConstants.MedicareCardColors.Yellow,
      ];
      if (cardColor !== null && colorsRequiringDays.includes(cardColor)) {
        daysRequired = true;
      }
      // The aon-date component is taking this as a literal string, and checking truthiness on it
      return daysRequired ? '' : 'true';
    };
  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-hambs.js